module.exports = __webpack_public_path__ + "static/media/loading.2d606956.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.svg
// module id = 28
// module chunks = 0